/**
 * Which of a world's two pointers the game page loads (ADR-050 amendment of 2026-09-26): `published.json`,
 * the version a publish shipped and the one a live map server follows, or `current.json`, the newest local
 * compile, which the development map server follows under `bun run dev:game`. The page loads its world
 * before it connects, so it cannot wait for the version the map server announces; the pointer comes from
 * the `config.json` beside the page instead, which the dev server writes as `current` and the Pages build as
 * `published`, so the page names the version its own map server runs.
 */

/**
 * A world pointer the page may follow.
 */
export type PagePointer = "current" | "published";

/**
 * Reads a pointer name.
 *
 * @param value A query or config value.
 * @returns The pointer it names, or null for anything else.
 */
function pointerNamed(value: string | null): PagePointer | null {
  return value === "current" || value === "published" ? value : null;
}

/**
 * The pointer the page loads: the page's `?pointer=` when it names one, else the one `config.json` names, else
 * `published`, so a page with no config and no query stays on what live runs.
 *
 * @param requested The page's `?pointer=` value, or null when it has none.
 * @param configured The pointer `config.json` names, or an empty string when it names none.
 * @returns The pointer.
 */
export function worldPointer(requested: string | null, configured: string): PagePointer {
  return pointerNamed(requested) ?? pointerNamed(configured) ?? "published";
}
